'use strict';

import {
  LISTING_STATE_CLOSED,
  LISTING_STATE_DRAFT,
  LISTING_STATE_PENDING_APPROVAL,
  LISTING_STATE_PUBLISHED,
} from '../../util/types';
import { countListingsByTypeTab } from '../../util/listingTypeTabs';

export const LISTING_TYPE_COUNT_STATES = [
  LISTING_STATE_DRAFT,
  LISTING_STATE_PENDING_APPROVAL,
  LISTING_STATE_PUBLISHED,
  LISTING_STATE_CLOSED,
];

export const LISTING_TYPE_COUNT_PAGE_SIZE = 100;
export const LISTING_TYPE_COUNT_FIELDS = ['state', 'publicData', 'privateData', 'title'];

const queryOwnListingsCountPage = (sdk, page, perPage) =>
  sdk.ownListings.query({
    page,
    perPage,
    states: LISTING_TYPE_COUNT_STATES,
    'fields.listing': LISTING_TYPE_COUNT_FIELDS,
  });

/**
 * Lightweight own-listings scan for Manage Listings type-tab counts.
 * Pages every own listing (draft / published / closed / pendingApproval)
 * with listing fields only — no images — then counts client-side so trash
 * and campaign-inbox rows can be excluded. Uses meta.totalPages.
 */
export const fetchOwnListingTypeCounts = async (
  sdk,
  { perPage = LISTING_TYPE_COUNT_PAGE_SIZE } = {}
) => {
  if (!sdk?.ownListings?.query) {
    throw new Error('Marketplace SDK with ownListings.query is required for type counts');
  }

  const all = [];
  let page = 1;
  let totalPages = 1;
  do {
    const response = await queryOwnListingsCountPage(sdk, page, perPage);
    all.push(...(response?.data?.data || []));
    totalPages = Number(response?.data?.meta?.totalPages) || page;
    page += 1;
  } while (page <= totalPages);

  return countListingsByTypeTab(all);
};
